module.exports = __webpack_public_path__ + "img/download-apk-hero.81a57c55.svg";